import { render, staticRenderFns } from "./AvatarCardMesaDirectiva.vue?vue&type=template&id=e0f1d20e&"
import script from "./AvatarCardMesaDirectiva.vue?vue&type=script&lang=js&"
export * from "./AvatarCardMesaDirectiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports